import * as $ from "jquery";
import { Grid } from 'ag-grid-community';

export default class SearchCustomersComponent {
    constructor() {
        this.componentSelector = ".ecom-customers";
        this.instance = this;
        this.grid = null;
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();
        }
    }

    bind() {
        let instance = this;
        
        $('#query').keypress(function (e) {
            var key = e.which;
            if (key == 13)
            {
                instance.searchCustomer(instance);
                return false;
            }
        }); 
    }

    searchCustomer(instance) {
        let query = $('#query').val();

        if (query == "") {
            bootbox.alert("Du måste ange ett sökord.");
            return;
        }

        axios({
            method: 'post',
            url: "/customers/searchbyquery",
            data: { query: query }
        }).then(function (response) {
            console.log(JSON.parse(response.data));
            instance.renderSearchResult(instance, JSON.parse(response.data));
        }).catch(function (response) {
            console.log(response);
            bootbox.alert("Inga kunder matchade sökningen.");
        });
    }

    deleteUserAndCustomer(instance, data) {
        var identifier = data.CustomerNumber;
        var customermarket = data.MarketId;

        axios({
            method: 'post',
            url: "/customer/deleteuserandcustomer",
            data: { identifier: identifier, customerMarket: customermarket }
        }).then(function (response) {
            if (response.data == "False") {
                $('#error').show();
            }
            else {
                instance.searchCustomer(instance);
            }
        }).catch(function (response) {
            console.log(response);
        });
    }

    buttonRenderer(params) {
        var button = document.createElement('button');
        button.className = 'user-customer-delete-btn';
        button.innerHTML = 'Ta bort';
        button.addEventListener('click', function () {
            params.context.deleteUserAndCustomer(params.context, params.data)
        });
        return button;
    }

    renderSearchResult(instance, data) {
        if (instance.grid == null) {
            instance.grid = {
                context: instance,
                columnDefs: [
                    { headerName: 'Id', field: 'Id', width: 100 },
                    { headerName: 'Marknad', field: 'MarketId', width: 150 },
                    { headerName: 'Kundnummer', field: 'CustomerNumber', width: 150 },
                    { headerName: 'Org.nummer', field: 'OrgNumber', width: 150 },
                    { headerName: 'E-post', field: 'Email' },
                    { headerName: 'Kundtyp', field: 'CustomerType' },
                    { headerName: 'Source', field: 'Source' },
                    { headerName: 'Senast ändrad', field: 'LastChanged' },
                    {
                        headerName: "",
                        field: 'CustomerNumber',
                        cellRenderer: instance.buttonRenderer,
                        width: 160,
                    }
                ],
                rowData: data,
                defaultColDef: { sortable: true, filter: true },
                domLayout: 'autoHeight'
            };

            var eGridDiv = document.querySelector('#report');
            new Grid(eGridDiv, instance.grid);
        }
        else {
            instance.grid.api.setRowData(data);
        }
    }
}